export default "__VITE_ASSET__jU6HAdIa__"